import Input from "./Input/Input";
import Select from "./Input/Select";

import "../css/FilterModal.css";

import CloseIcon from "../../../../../images/close.png";

export default function FilterModal({
  type,
  onClose,
  filter,
  filters,
  setFilters,
  teacherSelect,
  gradeSelect,
  modeSelect
}) {
  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleClear = () => {
    setFilters({
      "visitOn[gte]": "",
      "visitOn[lte]": "",
      user: "",
      section: "",
      sort: "visitOn",
    });
    teacherSelect.reset();
    gradeSelect.reset();
  };

  return (
    <div className="overlay">
      <div className="custom-modal">
        <div className="modal-header">
          <h2>{type === "export" ? "Export" : "Filter"}</h2>
          <button onClick={onClose} className="close-button">
            <img src={CloseIcon} alt="close" />
          </button>
        </div>
        <div className="modal-body">
          <div className="grid">
            <Input
              label="From"
              name={"visitOn[gte]"}
              placeholder={`From Date`}
              type="date"
              value={filters["visitOn[gte]"]}
              handleInput={handleChange}
            />
            <Input
              label="To"
              name={"visitOn[lte]"}
              placeholder={`To Date`}
              type="date"
              value={filters["visitOn[lte]"]}
              handleInput={handleChange}
            />
          </div>
          <div className="grid">
            <Select
              label="Grade"
              placeholder="Select Grade"
              options={gradeSelect.options}
              lock={!gradeSelect.options.length}
              selectedValue={gradeSelect.selectedOption || ""}
              setSelectedValue={gradeSelect.select}
            />
            <Select
              label="Teacher"
              placeholder="Select Teacher"
              options={teacherSelect.options}
              lock={!teacherSelect.options.length}
              selectedValue={teacherSelect.selectedOption || ""}
              setSelectedValue={teacherSelect.select}
            />
            <Select
              label="Mode"
              placeholder="Select Mode"
              options={modeSelect.options}
              lock={!modeSelect.options.length}
              selectedValue={modeSelect.selectedOption || ""}
              setSelectedValue={modeSelect.select}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button onClick={handleClear}>Clear</button>
          <button
            onClick={() => {
              filter(filters);
              onClose();
            }}
          >
            {type === "export" ? "Export" : "Filter"}
          </button>
        </div>
      </div>
    </div>
  );
}
